import { render, staticRenderFns } from "./PricingForm.vue?vue&type=template&id=1228b0a0&"
import script from "./PricingForm.vue?vue&type=script&lang=js&"
export * from "./PricingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports